import React, { forwardRef } from "react";
import noImage from "../../../assets/Images/body-bg.jpg";
import { IHeadquarterIcons } from "../../../models/response/IHeadquarterResponse";
import { formatMessage } from "../../../translations/format-message";
import { ISMRList } from "../../../models/response/ISMRResponse";
import { FormattedMessage } from "react-intl";
import { formatNumberWithCommas } from "../../../constants/constants";

interface IProps {
  index: number;
  item: ISMRList;
  onClick: () => void;
  isActive: boolean;
  icons: IHeadquarterIcons;
}

const BookingCard = forwardRef<HTMLDivElement, IProps>(
  ({ index, item, onClick, isActive, icons }, ref) => {

    const saleItems = item.SaleRecord[0]?.SaleItem?.length ? item.SaleRecord[0]?.SaleItem : [];
    const saleRecord = item.SaleRecord[0];
    const showTreatmentIcon =  saleItems.filter((record=> record.ItemType === 0))?.length > 0 ? true : false;
    const showProductIcon =  saleItems.filter((record=> record.ItemType === 1))?.length > 0 ? true : false;
    return (
      <div>
        <div
          className={`booking-item ${isActive ? "active" : ""}`}
          key={index}
          ref={ref}
          onClick={onClick}
        >
          <div className="row g-0 small text-primary align-items-end">
            <div className="col-6 border-bottom p-1">
              <p>{item.Date}</p>
            </div>
            <div className="col-6 border-bottom p-1 text-end">
              <p>{item.Time}</p>
            </div>
          </div>
          <div className="row g-0 px-1 pt-1">
            <p><strong>{formatMessage("incharge")}: </strong> {item.StaffName}</p>
          </div>
          <div className="row g-0 px-1 pb-1 small align-items-end">          
            
              {
                showTreatmentIcon &&
                <div className="col-6">
                <img
                  src={icons.TreatmentIcon || noImage}
                  alt="Treatment icon"
                  className="badge_icon"
                /><br />
                <FormattedMessage id="treatment" />
                </div>
              }
              {
                showProductIcon &&
                <div className="col-6">
                <img
                  src={icons.ProductIcon || noImage}
                  alt="Product icon"
                  className="badge_icon"
                /><br />
                <FormattedMessage id="merchandise" />
                </div>
              }
            
          </div>
          <div className="row g-0 bg-primary p-1">
            <div className="col-6">
              <h4 className="m-0  text-white">{formatMessage("payment")}:</h4>
            </div>
            <div className="col-6">
              <h4 className="m-0  text-white text-end" ><i className="bi bi-currency-yen"></i>{saleRecord && formatNumberWithCommas(saleRecord.SaleRecordPaymentStatus === true &&
                saleRecord.PaymentType === 0 ? 0 : saleRecord.Total)} </h4>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default BookingCard;
